'use client'

import useIsClient from "../../../hooks/useIsClient"
import { ReactNode } from "react"

/**
 * @description
 * prevents pre-rendering on the server for client components that rely on browser-only functionality
 *
 * prefer pre-rendering whenever possible
 *
 * use NoPreRender when:
 * - Using checks like typeof window !== 'undefined' in your rendering logic
 * - Using browser-only APIs like window or localStorage in your rendering logic
 * - Using time-dependent APIs such as the Date() constructor in your rendering logic
 * */
export const NoPreRender = ({ children }: { children: ReactNode }) => {
    const isClient = useIsClient()
    return isClient && children
}
